
import Comments from '@/vue/_components/article/comments/comments.web.vue'
jdw.components.Comments = Comments

import './comments.vue.js'